import { SafeResourceUrl } from '@angular/platform-browser';

export class LinkItem {

    constructor(
        public name: string,
        public url: string,
        public id?: number | null,
        public faviconUrl?: SafeResourceUrl | null,
        public icon?: string
    ){}
}
